import React, { useState } from 'react';
import { ROOMS } from '../../rooms';
import { usePrintStudio } from '../../state/printStudio';

// PrintShopScreen — the studio screen beside the print shop's counter, pressable
// (2026-10-31). The screen is in the model (scripts/make_printshop.mjs: a tall
// display reading the four things made here); this lays an invisible hit box
// over it (rooms.js `printshop.screen`, room space at the room's fit `k`, like
// RoomDecals) so the studio opens with or without a clerk on shift — a shop
// nobody is cast in yet is still a shop you can use.
export default function PrintShopScreen({ roomId, k = 1 }) {
  const box = ROOMS[roomId]?.printshop?.screen || null;
  const show = usePrintStudio((s) => s.show);
  const [hot, setHot] = useState(false);
  if (!box) return null;
  return (
    <mesh
      position={[box.pos[0] * k, box.pos[1] * k, box.pos[2] * k]}
      onClick={(e) => {
        e.stopPropagation();
        if (e.delta > 6) return;   // the end of a drag-to-look, not a press
        show({ zone: roomId });
      }}
      onPointerOver={(e) => { e.stopPropagation(); setHot(true); document.body.style.cursor = 'pointer'; }}
      onPointerOut={() => { setHot(false); document.body.style.cursor = 'auto'; }}
    >
      <boxGeometry args={[box.size[0] * k, box.size[1] * k, box.size[2] * k]} />
      {/* Unseen, but there to be pressed; a faint glow when the pointer is on it. */}
      <meshBasicMaterial color="#ff4fa3" transparent opacity={hot ? 0.12 : 0} depthWrite={false} colorWrite={hot} toneMapped={false} />
    </mesh>
  );
}
